import React from 'react'
import { StandardOpenModalButton } from 'src/components/ModalForms/ModalButtons'
import { AutomateDocumentIcon } from 'src/components/Icons/FileType'
import {
  Control,
  CONTROL_STATUS,
} from '@trustero/trustero-api-web/lib/model/control_pb'
import { useCanPerformAction } from 'src/app/AppAuth/AppAuth.hooks'
import { CAPABILITY } from '@trustero/trustero-api-web/lib/authz/permissions_pb'
import { ModalFormId } from '../../../../components/ModalForms'
import { AddConnectionModal } from '../../../../components/ModalForms/Evidence/AddEvidence/AddConnection'
import {
  StandardButtonSize,
  StandardButtonVariant,
} from '../../../../components/Reusable/Buttons'

export const AddConnectionModalToggle = ({
  control,
  buttonVariant,
  modalFormId,
}: {
  control: Control.AsObject
  buttonVariant: StandardButtonVariant
  modalFormId: ModalFormId
}): JSX.Element => {
  const canAddEvidence = useCanPerformAction<Control.AsObject>(
    CAPABILITY.CAN_ADD_EVIDENCE,
    control,
  )
  const isNotApplicable = control.status === CONTROL_STATUS.NOTAPPLICABLE
  return (
    <>
      {!isNotApplicable && (
        <AddConnectionModal modalFormId={modalFormId} controlId={control.id} />
      )}
      <StandardOpenModalButton
        modalId={modalFormId}
        variant={buttonVariant}
        size={StandardButtonSize.SMALL}
        text=""
        isDisabled={!canAddEvidence}
        disabledReason="You do not have permission to add evidence."
      >
        <AutomateDocumentIcon width="15px" height="15px" />
        Connect Automated Evidence
      </StandardOpenModalButton>
    </>
  )
}
